import { Subject } from 'rxjs';
import { filter } from 'rxjs/operators';
import * as i0 from "@angular/core";
var AppService = /** @class */ (function () {
    function AppService() {
        this.reloadData$ = new Subject();
    }
    AppService.prototype.reloadData = function () {
        this.reloadData$.next(true);
    };
    AppService.prototype.onReloadData = function () {
        return this.reloadData$.pipe(filter(function (val) { return !!val; }));
    };
    AppService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AppService_Factory() { return new AppService(); }, token: AppService, providedIn: "root" });
    return AppService;
}());
export { AppService };
